/**
 * "Esqueci minha senha" — o pedido do link (historia 1.4).
 *
 * A resposta e **deliberadamente a mesma** para e-mail com conta e sem conta: o backend
 * gastou o mesmo tempo e devolveu o mesmo corpo justamente para que ninguem descubra daqui
 * quem tem cadastro. Esta tela mostra a `mensagem` como veio e nao acrescenta nada que
 * distinga os dois casos — nem um "enviamos para o seu e-mail" a mais.
 *
 * Por isso, tambem, o formulario nao some depois do envio: quem digitou o e-mail errado
 * precisa poder corrigir sem recarregar a pagina.
 */

import { Link, createRoute } from '@tanstack/react-router'
import { type FormEvent, useState } from 'react'

import { ErroDaApi, MENSAGEM_DE_ERRO_DESCONHECIDO } from '@/api/erros'
import { solicitarRedefinicaoDeSenha } from '@/modulos/identidade/api'
import { useMutation } from '@tanstack/react-query'
import { rotaPublica } from './publico'
import './entrar.css'

const FALTA_EMAIL = 'Informe o e-mail.'

function EsqueciMinhaSenha() {
  const [email, setEmail] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [aviso, setAviso] = useState<string | null>(null)

  const pedir = useMutation({
    mutationFn: (endereco: string) => solicitarRedefinicaoDeSenha({ email: endereco }),
  })

  function enviar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault()

    if (email.trim() === '') {
      setAviso(null)
      setErro(FALTA_EMAIL)
      return
    }

    setErro(null)
    pedir.mutate(email.trim(), {
      onSuccess: (resposta) => {
        setAviso(resposta.mensagem)
      },
      onError: (falha: unknown) => {
        setAviso(null)
        setErro(falha instanceof ErroDaApi ? falha.message : MENSAGEM_DE_ERRO_DESCONHECIDO)
      },
    })
  }

  return (
    <>
      <h1 className="entrada__titulo">Esqueci minha senha</h1>
      <p className="entrada__texto">
        Informe o e-mail cadastrado. Se houver conta com ele, um link para criar uma senha nova
        chega em instantes — o link vale por pouco tempo e serve uma vez só.
      </p>

      <form className="entrada__formulario" onSubmit={enviar} noValidate>
        <div className="entrada__campo">
          <label className="entrada__rotulo" htmlFor="campo-email">
            E-mail
          </label>
          <input
            id="campo-email"
            className="entrada__entrada"
            type="email"
            name="email"
            autoComplete="username"
            autoFocus
            value={email}
            onChange={(evento) => {
              setEmail(evento.target.value)
            }}
          />
        </div>

        {erro === null ? null : (
          <p className="entrada__erro" role="alert">
            {erro}
          </p>
        )}
        {aviso === null ? null : (
          <p className="entrada__aviso" role="status">
            {aviso}
          </p>
        )}

        <button className="entrada__botao" type="submit" disabled={pedir.isPending}>
          {pedir.isPending ? 'Enviando…' : 'Enviar link'}
        </button>
      </form>

      <Link to="/entrar" className="entrada__link">
        Voltar para entrar
      </Link>
    </>
  )
}

export const rotaEsqueciMinhaSenha = createRoute({
  getParentRoute: () => rotaPublica,
  path: '/esqueci-minha-senha',
  component: EsqueciMinhaSenha,
})
